import { ToolbarMolecule } from '@justomx/atlas-components'
import type { ReactNode } from 'react'
import styled from 'styled-components'

import { ContainerAtom } from 'components/atoms/Container.atom'
import { ModalContainer } from 'components/atoms/ModalContainer.atom'

interface ModalOrganismProps {
  title: string
  children: ReactNode
  actionIcon: string
  onAction: () => void
  onSearch?: (value: string) => void
}

export const FixedTopDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  z-index: 1000;
`

export const ModalOrganism = (props: ModalOrganismProps) => {
  const { children, onSearch, ...toolbarProps } = props

  return (
    <ContainerAtom>
      <FixedTopDiv>
        <ToolbarMolecule
          {...toolbarProps}
          searchMode={!!onSearch}
          onChangeSearch={(e) => {
            onSearch?.(`${e.target.value}`)
          }}
        />
      </FixedTopDiv>

      <ModalContainer>{children}</ModalContainer>
    </ContainerAtom>
  )
}
